import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What is your typical response time?',
      answer: 'We respond to all consultation requests within 24 hours during business days. For urgent inquiries, we typically respond within 4-6 hours. Our team is available Monday through Friday, 9 AM to 6 PM IST.'
    },
    {
      question: 'Do you offer free consultations?',
      answer: 'Yes, we offer a complimentary initial consultation to discuss your project requirements, timeline, and budget. This 30-60 minute session helps us understand your needs and allows you to evaluate if we\'re the right fit for your project.'
    },
    {
      question: 'What information should I prepare for the consultation?',
      answer: 'To make the most of our consultation, prepare: your project goals and objectives, target audience information, desired features and functionality, timeline expectations, budget range, and any existing documentation or designs. The more details you provide, the better we can tailor our recommendations.'
    },
    {
      question: 'Do you work with startups and enterprises?',
      answer: 'Absolutely! We work with organizations of all sizes, from early-stage startups building their MVP to established enterprises requiring complex SaaS solutions. Our approach is tailored to each client\'s specific needs, resources, and growth stage.'
    },
    {
      question: 'What is your project engagement process?',
      answer: 'Our process begins with a discovery phase to understand your requirements, followed by proposal and contract negotiation. We then move into design and development sprints with regular check-ins, followed by testing, deployment, and ongoing support. We maintain transparent communication throughout.'
    },
    {
      question: 'Do you provide ongoing support after launch?',
      answer: 'Yes, we offer comprehensive post-launch support including maintenance, updates, bug fixes, and feature enhancements. We provide flexible support packages tailored to your needs, from basic maintenance to full-service ongoing development partnerships.'
    },
    {
      question: 'What technologies do you specialize in?',
      answer: 'We specialize in modern web technologies including React, Node.js, Python, and cloud platforms like AWS and Azure. Our tech stack is chosen based on your specific requirements, scalability needs, and long-term maintenance considerations.'
    },
    {
      question: 'How do you handle project pricing?',
      answer: 'We offer both fixed-price and time-and-materials pricing models depending on project scope and requirements. After our initial consultation, we provide a detailed proposal with transparent pricing, deliverables, and timeline. We believe in no surprises and clear communication about costs.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-headline text-foreground mb-3 md:mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            Find answers to common questions about our consultation process, services, and how we work with clients.
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs?.map((faq, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-lg overflow-hidden hover:border-primary/50 transition-colors duration-200"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 md:p-6 text-left"
              >
                <span className="text-base md:text-lg font-semibold font-headline text-foreground pr-4">
                  {faq?.question}
                </span>
                <Icon
                  name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                  size={20}
                  color="var(--color-primary)"
                  className="flex-shrink-0"
                />
              </button>
              
              {openIndex === index && (
                <div className="px-4 md:px-6 pb-4 md:pb-6">
                  <p className="text-sm md:text-base text-muted-foreground font-body leading-relaxed">
                    {faq?.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 text-center bg-muted/50 rounded-xl p-6 md:p-8">
          <Icon name="HelpCircle" size={40} color="var(--color-primary)" className="mx-auto mb-4" />
          <h3 className="text-lg md:text-xl font-semibold font-headline text-foreground mb-2">
            Still have questions?
          </h3>
          <p className="text-sm md:text-base text-muted-foreground font-body mb-4">
            We're here to help! Reach out to our team and we'll get back to you promptly.
          </p>
          <a
            href="mailto:hello@devontis.com"
            className="inline-flex items-center space-x-2 text-sm md:text-base text-primary hover:underline font-body"
          >
            <Icon name="Mail" size={18} />
            <span>hello@devontis.com</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;